module.exports = __webpack_public_path__ + "static/media/loaderIcon.115ed8ee.svg";